import React, { ReactElement } from 'react';
import { Checkbox } from '@mui/material';
import { StyledRowBox } from '../../theme/StyledElements';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { SelectComponent } from '../SelectComponent';
import { getCheckedImage } from '../../utils';

interface TimeComponentProps {
    modify: boolean;
    value: string;
    checked: boolean | undefined;
    onTimeChange: Function;
    onCheckedChange: Function;
}

export function TimeComponent({
    modify,
    value,
    checked,
    onTimeChange,
    onCheckedChange
}: TimeComponentProps): ReactElement {
    return (
        <StyledRowBox>
            {modify ? (
                <Checkbox
                    id="checked"
                    name="checked"
                    checked={checked}
                    onChange={(event): void => onCheckedChange(event.target.checked)}
                    sx={{
                        color: '#134C03',
                        '&.Mui-checked': {
                            color: '#134C03'
                        }
                    }}
                />
            ) : (
                getCheckedImage(checked)
            )}
            <AccessTimeIcon
                style={{
                    color: '#134C03',
                    height: '35px',
                    width: '35px',
                    marginTop: '10px',
                    marginRight: '10px'
                }}
            />
            <SelectComponent
                disabled={modify}
                value={value}
                onTextChange={(content: string): void => {
                    onTimeChange(content);
                }}
            />
        </StyledRowBox>
    );
}
